import _ from 'lodash';
import { EventEmitter } from 'events';
import AppDispatcher from '../dispatcher/AppDispatcher';
import PaymentLinkConstants from '../constants/PaymentLinkConstants';

let _status = {};
let _links = {};

const PaymentLinkStore = _.extend({}, EventEmitter.prototype, {
	getStatus: function (booking_id) {
		return _status[booking_id] || PaymentLinkConstants.STATUS.INITIAL;
	},

	getLink: function (booking_id) {
		return _links[booking_id] || null;
	},

	emitChange: function () {
		this.emit('change');
	},

	addChangeListener: function (callback) {
		this.on('change', callback);
	},

	removeChangeListener: function (callback) {
		this.removeListener('change', callback);
	},
});

AppDispatcher.register(function (payload) {
	let action = payload.action;

	switch (action.actionType) {
		case PaymentLinkConstants.PAYMENT_LINK_LOADING:
			_status[action.data.booking_id] = PaymentLinkConstants.STATUS.BUSY;
			break;

		case PaymentLinkConstants.PAYMENT_LINK_SUCCESS:
			_status[action.data.booking_id] = PaymentLinkConstants.STATUS.SUCCESS;
			if (action.data.payment_link) {
				_links[action.data.booking_id] = action.data.payment_link;
			}
			break;

		case PaymentLinkConstants.PAYMENT_LINK_FAILED:
			_status[action.data.booking_id] = PaymentLinkConstants.STATUS.FAILED;
			break;

		case PaymentLinkConstants.PAYMENT_LINK_RESET:
			delete _status[action.data.booking_id];
			delete _links[action.data.booking_id];
			break;

		default:
			return true;
	}

	// If action was responded to, emit change event
	PaymentLinkStore.emitChange();

	return true;
});

export default PaymentLinkStore;
